var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4768 13.6396L16.9918 22.1656C17.0087 22.266 16.9946 22.3692 16.9514 22.4614C16.9081 22.5536 16.8377 22.6303 16.7497 22.6814C16.6616 22.7325 16.56 22.7555 16.4586 22.7474C16.3571 22.7392 16.2605 22.7002 16.1818 22.6356L12.6018 19.9486C12.4289 19.8195 12.219 19.7498 12.0033 19.7498C11.7875 19.7498 11.5776 19.8195 11.4048 19.9486L7.81875 22.6346C7.74007 22.6991 7.64361 22.738 7.54225 22.7462C7.44088 22.7544 7.33942 22.7315 7.25141 22.6805C7.16341 22.6296 7.09303 22.553 7.04967 22.461C7.00631 22.369 6.99204 22.266 7.00875 22.1656L8.52275 13.6396",
    stroke: "#009CC5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.75C15.3137 14.75 18 12.0637 18 8.75C18 5.43629 15.3137 2.75 12 2.75C8.68629 2.75 6 5.43629 6 8.75C6 12.0637 8.68629 14.75 12 14.75Z",
    stroke: "#009CC5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExe);
export default __webpack_public_path__ + "static/media/exe.f834de4dbfadc43d78dddd2bcb0dd001.svg";
export { ForwardRef as ReactComponent };